import moment from "moment";
import Select from "react-select";
import Cards from "react-credit-cards";
import OtpInput from "react-otp-input";
import React, { Component, Fragment } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import {
  Container,
  Col,
  Row,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Navbar,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CustomInput,
  CardImg,
  Table,
  Tooltip,
} from "reactstrap";
import { MdEdit } from "react-icons/md";
import { GoVerified, GoUnverified } from "react-icons/go";

import "../../styles/login.css";
import bn from "../../utils/bemnames";
import * as Server from "../../Server";
import PageSpinner from "../../components/PageSpinner";
import * as GeneralFunctions from "../../GeneralFunctions";
import NotificationSystem from "react-notification-system";
import { NOTIFICATION_SYSTEM_STYLE } from "../../utils/constants";
// import DefaultImage from "../../assets/img/defaultUser.png";

const bem = bn.create("header");

class WebAppRegistrationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clubId: "",
      parentId: "",
      adult: {},
      player: {},
      childs: [],
      selectedChild: {},
      submitType: "",
      showLoader: false,
      disabledFields: false,
      playerDisabledFields: false,
      verificationModal: false,
      registerFormFieldsAdult: [],
      registerFormFieldsPlayers: [],
      wavierFormFieldsAdult: [],
      wavierFormFieldsPlayers: [],
      registerChild: false,
      showPayButton: false,
      registerFor: "parent",
      registerNewChild: false,
      newChildId: "",
      showPaymentPage: false,
      cvc: "",
      name: "",
      number: "",
      expiry: "",
      cardType: "",
      focus: "number",
      stripeCards: [],
      selectedCard: {},
      eventPriceDetails: {},
      paymentConfirmationModal: false,
      eventId: "",
      event: {},
      team: {},
      unverifiedEmailTooltip: false,
      verifiedEmailTooltip: false,
      unverifiedPhoneTooltip: false,
      verifiedPhoneTooltip: false,
      phoneOtp: "",
      phoneOtpSent: false,
      phoneOtpVerified: false,
      emailOtp: "",
      emailOtpSent: false,
      emailOtpVerified: false,
      fullPayment: true,
      selectedTabIndex: 0,
      installments: 0,
      installmentDates: [],

      defaultPage: true,
      clubSelectPage: true,
      SPIParentCampPage: true,
      registrationFormPage: false,
      SPIRegistration: false,
      firstName: "",
      lastName: "",
      clubs: [],
      SPIClub: {},
      SPIParentCamps: [],
      SPICamps: [],
      selectedClub: {},
      selectedClubIndex: null,
      selectedSPIParentCamp: {},
      selectedSPIParentCampIndex: null,
      selectedSPICamp: {},
      selectedSPICampIndex: null,
      scoccerClub: "",
      allTeams: [],
      allTeamsOptions: [],
      selectedTeam: {},
      allCamps: [],
      allCampsOptions: [],
      selectedCamp: {},
    };
    this.onSubmit = this.onSubmit.bind(this);
  }

  dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(",")[0].indexOf("base64") >= 0)
      byteString = atob(dataURI.split(",")[1]);
    else byteString = unescape(dataURI.split(",")[1]);

    // separate out the mime component
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  componentDidMount() {
    if (!this.props.location.state || !this.props.location.state.users) {
      window.location.assign(`${window.location.origin}/parentlist`);
    }
    this.getClubs();
    let user = GeneralFunctions.getAuthUser();
    if (!user) {
      GeneralFunctions.clearFullLocalStorage();
      window.location.assign(`${window.location.origin}/userlogin`);
    }
    this.setState({
      firstName: user && user.firstName ? user.firstName : "",
      lastName: user && user.lastName ? user.lastName : "",
    });
  }

  getClubs = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "user/clubs?APIVersion=v2",
        method: "GET",
      });
      if (response && response.success) {
        this.setState(
          {
            showLoader: false,
            clubs: response.clubs.filter((club) => !club.SPIEvent) || [],
            SPIClub: response.clubs.find((club) => club.SPIEvent) || {},
          },
          () => this.getRushNationalCamps()
        );
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getRushNationalCamps = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccerapp/rushNational/camps",
        method: "GET",
        token: "marketplaceAccessToken",
      });
      if (response) {
        this.setState({
          showLoader: false,
          SPIParentCamps: response.camps,
          SPICamps: response.camps.length ? response.camps[0].camps : [],
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getTeams = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccerapp/team/list",
        method: "POST",
        data: {
          version: "v2",
          clubId: this.state.clubId,
          parentId: this.state.parentId,
          childId: this.state.selectedChild.value,
        },
        token: "marketplaceAccessToken",
      });
      if (response && response.success) {
        let allTeamsOptions = response.teams.map((team) => ({
          label: team.name,
          value: team._id,
        }));
        this.setState({
          showLoader: false,
          allTeams: response.teams,
          allTeamsOptions,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getCamps = async (result) => {
    try {
      let team = this.state.allTeams.find((team) => team._id === result.value);
      this.setState({
        showLoader: true,
        team: team ? team : {},
        selectedTeam: result,
        selectedCamp: {},
      });
      let response = await Server.request({
        url: "rushsoccerapp/v2/getCamps",
        method: "POST",
        data: {
          SPIEvent: false,
          version: "v2",
          clubId: this.state.clubId,
          parentId: this.state.parentId,
          childId: this.state.selectedChild.value,
          teamIds: [team._id],
        },
        token: "marketplaceAccessToken",
      });
      if (response && response.success) {
        let allCampsOptions = response.camps.map((camp) => ({
          label: camp.name,
          value: camp.camp._id,
        }));
        this.setState({
          showLoader: false,
          allCamps: response.camps.map((camp) => camp.camp),
          allCampsOptions,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getProcessingFees = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/processingFee",
        method: "POST",
        data: {
          SPIEvent: true,
          childId: this.state.newChildId || this.state.selectedChild.value,
          campId: this.state.eventId,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          eventPriceDetails: response,
          showPaymentPage: true,
          registrationFormPage: true,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getRegistrationForm = async (clubId) => {
    try {
      this.setState({ showLoader: true });
      if (!clubId) {
        this.setState({
          registerFormFieldsAdult: [],
          registerFormFieldsPlayers: [],
        });
        return;
      }
      let response = await Server.request({
        url: `rushsoccer/registration/form?clubId=${clubId}`,
        method: "GET",
      });
      if (
        response.registrationFormDetails &&
        response.registrationFormDetails.registerForm
      ) {
        let allFields = response.registrationFormDetails.registerForm.reduce(
          (previousValue, currentValue) => {
            previousValue.push(...currentValue.fields);
            return previousValue;
          },
          []
        );
        let playerFields = allFields.filter(
          (form) =>
            form.for.value === "player" &&
            // form.inputType !== "fileupload" && //remove fileuploads
            form._id !== "2e3b1830-6147-4955-a3b3-b8e3a2db3d14"
        );
        let wavierFormFieldsPlayers = allFields.filter(
          (form) => form.for.value === "player" && form.inputType === "waviers"
        );
        let adultFields = allFields
          .filter(
            (form) => form.for.value === "adult"
            // && form.inputType !== "fileupload" //remove fileuploads
          )
          .map((field) =>
            field.keyName === "photo"
              ? Object.assign(field, { keyName: "photo1" })
              : field
          );
        let wavierFormFieldsAdult = allFields.filter(
          (form) => form.for.value === "adult" && form.inputType === "waviers"
        );
        this.setState({
          showLoader: false,
          clubId,
          registerFormFieldsPlayers: playerFields,
          wavierFormFieldsPlayers,
          registerFormFieldsAdult: adultFields,
          wavierFormFieldsAdult,
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  registerForSPI = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.chatServerRequest({
        url: "api/v1/setName",
        method: "POST",
        data: {
          rushUserType: "adult",
          version: "v2",
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          scoccerClub: this.state.scoccerClub,
          clubId: this.state.clubId,
        },
      });
      if (response && response.success) {
        GeneralFunctions.setAuthUser(response.user);
        this.setState({
          showLoader: false,
        });
        this.props.history.push({
          pathname: `/event/register/${this.state.selectedSPIParentCamp.name}?eventId=${this.state.selectedSPICamp._id}`,
          state: {
            redirect: true,
            SPIParentCamp: this.state.selectedSPIParentCamp.name,
            eventId: this.state.selectedSPICamp._id,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            phone: response.user.username,
          },
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  setNameAPI = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.chatServerRequest({
        url: "api/v1/setName",
        method: "POST",
        data: {
          rushUserType: "adult",
          version: "v2",
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          scoccerClub: this.state.selectedClub.name,
          clubId: this.state.selectedClub._id,
        },
      });
      if (response && response.success) {
        GeneralFunctions.setAuthUser(response.user);
        this.setState(
          {
            showLoader: false,
            registrationFormPage: true,
            phoneOtpVerified: true,
            adult: {
              firstName: this.state.firstName,
              lastName: this.state.lastName,
              phone: response.user.username,
            },
          },
          () => this.getRegistrationForm(this.state.selectedClub._id)
        );
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateState = async (type, key, value) => {
    if (value === "on") {
      switch (type) {
        case "adult":
          value = !this.state.adult[key];
          break;
        case "player":
          value = !this.state.player[key];
          break;
        default:
          break;
      }
    }
    if (key === "phone" || key === "playerPhone") {
      if (value.length > 10) {
        return true;
      }
    }
    switch (type) {
      case "adult":
        this.setState((prevState) => ({
          adult: {
            ...prevState.adult,
            [key]: value,
          },
        }));
        break;
      case "player":
        this.setState((prevState) => ({
          player: {
            ...prevState.player,
            [key]: value,
          },
        }));
        break;
      default:
        break;
    }
  };

  onSubmit = async (event) => {
    event.preventDefault();
    try {
      let formData = new FormData();
      this.setState({ showLoader: true });
      if (this.state.registerFor === "parent") {
        if (!this.state.phoneOtpVerified || !this.state.emailOtpVerified) {
          throw Error("Verify email and phone first");
        }
        let adultFileFields = this.state.registerFormFieldsAdult.filter(
          (field) => field.inputType === "dropdown"
        );
        for (let index = 0; index < adultFileFields.length; index++) {
          const adultFileField = adultFileFields[index];
          if (adultFileField.required) {
            if (!this.state.adult[adultFileField.keyName]) {
              throw Error(`Select the ${adultFileField.placeholder}`);
            }
          }
        }
        let adultFileUploadFields = this.state.registerFormFieldsAdult
          .filter((field) => field.inputType === "fileupload")
          .map((field) => Object.assign(field, { for: "adult" }));
        for (let index = 0; index < adultFileUploadFields.length; index++) {
          const adultFileUploadField = adultFileUploadFields[index];
          if (adultFileUploadField.required) {
            if (this.state.adult[adultFileUploadField.keyName]) {
              formData.append(
                [adultFileUploadField.keyName],
                this.state.adult[adultFileUploadField.keyName]
              );
            } else {
              throw Error(`Select the ${adultFileUploadField.placeholder}`);
              // let blob = this.dataURItoBlob(DefaultImage);
              // formData.append(
              //   [adultFileUploadField.keyName],
              //   blob,
              //   "defaultUser.png"
              // );
            }
          } else {
            if (this.state.adult[adultFileUploadField.keyName])
              formData.append(
                [adultFileUploadField.keyName],
                this.state.adult[adultFileUploadField.keyName]
              );
          }
        }
        if (this.state.submitType === "registerAdult") {
          formData.append("clubId", this.state.clubId);
          formData.append("adult", JSON.stringify(this.state.adult));
          formData.append("registerFor", "parent");
          let deleteKeys = adultFileUploadFields.map((fields) => ({
            keyName: fields.keyName,
            for: fields.for,
          }));
          if (deleteKeys && deleteKeys.length)
            formData.append("deleteKeys", JSON.stringify(deleteKeys));
          let response = await Server.staticTokenServerRequest(
            {
              url: "rushUser/web/register",
              method: "POST",
              data: formData,
            },
            false
          );
          if (response) {
            if (response.success) {
              if (response.user.child.length) {
                response.user.child = response.user.child.filter(
                  (kid) => !kid.systemGenerated
                );
              }
              this.setState({
                selectedTabIndex: 1,
                showLoader: false,
                disabledFields: true,
                registerChild: true,
                parentId: response.user._id,
                adult: response.user.data,
                childs: response.user.child.length ? response.user.child : [],
                selectedChild: response.user.child.length
                  ? {
                      value: response.user.child[0]._id,
                      label: `${response.user.child[0].data.firstName} ${response.user.child[0].data.lastName}`,
                    }
                  : {},
                player: response.user.child.length
                  ? response.user.child[0].data
                  : {},
                registerNewChild: response.user.child.length ? false : true,
                stripeCards:
                  response.user.stripeCards && response.user.stripeCards.length
                    ? response.user.stripeCards
                    : [],
                selectedCard:
                  response.user.stripeCards && response.user.stripeCards.length
                    ? response.user.stripeCards[0]
                    : {},
              });
              this.toggleVerificationModal();
              this.notificationSystem.addNotification({
                message: response.message,
                level: "success",
              });
            }
          }
          window.scrollTo(0, 0);
        } else {
          this.setState({ showLoader: false });
          this.toggleVerificationModal();
        }
      } else {
        if (!this.state.phoneOtpVerified || !this.state.emailOtpVerified) {
          throw Error("Verify email and phone first");
        }
        let playerFileFields = this.state.registerFormFieldsPlayers.filter(
          (field) => field.inputType === "dropdown"
        );
        for (let index = 0; index < playerFileFields.length; index++) {
          const playerFileField = playerFileFields[index];
          if (playerFileField.required) {
            if (!this.state.player[playerFileField.keyName]) {
              throw Error(`Select the ${playerFileField.placeholder}`);
            }
          }
        }
        let playerFileUploadFields = this.state.registerFormFieldsPlayers
          .filter((field) => field.inputType === "fileupload")
          .map((field) => Object.assign(field, { for: "player" }));
        for (let index = 0; index < playerFileUploadFields.length; index++) {
          const playerFileUploadField = playerFileUploadFields[index];
          if (playerFileUploadField.required) {
            if (this.state.player[playerFileUploadField.keyName]) {
              formData.append(
                [playerFileUploadField.keyName],
                this.state.player[playerFileUploadField.keyName]
              );
            } else {
              throw Error(`Select the ${playerFileUploadField.placeholder}`);
              // let blob = this.dataURItoBlob(DefaultImage);
              // formData.append(
              //   [playerFileUploadField.keyName],
              //   blob,
              //   "defaultUser.png"
              // );
            }
          } else {
            if (this.state.player[playerFileUploadField.keyName])
              formData.append(
                [playerFileUploadField.keyName],
                this.state.player[playerFileUploadField.keyName]
              );
          }
        }
        if (this.state.submitType === "registerChild") {
          formData.append("clubId", this.state.clubId);
          if (!this.state.registerNewChild)
            formData.append("childId", this.state.selectedChild.value);
          formData.append("parentId", this.state.parentId);
          formData.append("player", JSON.stringify(this.state.player));
          formData.append("registerFor", "child");
          formData.append("teamId", this.state.team._id);
          formData.append("campId", this.state.eventId);
          let deleteKeys = playerFileUploadFields.map((fields) => ({
            keyName: fields.keyName,
            for: fields.for,
          }));
          if (deleteKeys && deleteKeys.length)
            formData.append("deleteKeys", JSON.stringify(deleteKeys));
          let response = await Server.staticTokenServerRequest(
            {
              url: "rushUser/web/register",
              method: "POST",
              data: formData,
            },
            false
          );
          if (response) {
            if (response.success) {
              if (response.user.child.length) {
                response.user.child = response.user.child.filter(
                  (kid) => !kid.systemGenerated
                );
              }
              this.setState(
                {
                  showLoader: false,
                  registrationFormPage: false,
                  clubSelectPage: false,
                  playerDisabledFields: true,
                  adult: response.user.data,
                  childs: response.user.child.length ? response.user.child : [],
                  selectedChild: response.user.child.length
                    ? {
                        value: response.user.child[0]._id,
                        label: `${response.user.child[0].data.firstName} ${response.user.child[0].data.lastName}`,
                      }
                    : {},
                  player: response.user.child.length
                    ? response.user.child[0].data
                    : {},
                  stripeCards:
                    response.user.stripeCards &&
                    response.user.stripeCards.length
                      ? response.user.stripeCards
                      : [],
                  selectedCard:
                    response.user.stripeCards &&
                    response.user.stripeCards.length
                      ? response.user.stripeCards[0]
                      : {},
                  newChildId: response.newChildId,
                },
                () => this.getTeams()
              );
              this.toggleVerificationModal();
              this.notificationSystem.addNotification({
                message: response.message,
                level: "success",
              });
            }
          }
          window.scrollTo(0, 0);
        } else {
          this.setState({ showLoader: false });
          this.toggleVerificationModal();
        }
      }
    } catch (error) {
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
      this.setState({
        showLoader: false,
      });
    }
  };

  handleChange = async (type, key, event) => {
    const fileUploaded = event.target.files[0];
    switch (type) {
      case "adult":
        this.setState((prevState) => ({
          adult: {
            ...prevState.adult,
            [key]: fileUploaded,
            [`${key}FileName`]: fileUploaded.name,
          },
        }));
        break;
      case "player":
        this.setState((prevState) => ({
          player: {
            ...prevState.player,
            [key]: fileUploaded,
            [`${key}FileName`]: fileUploaded.name,
          },
        }));
        break;
      default:
        break;
    }
    event.target.value = null;
  };

  payForEvent = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let response;
      if (this.state.fullPayment) {
        response = await Server.request({
          url: "rushsoccer/stripe/pay",
          method: "POST",
          data: {
            SPIEvent: true,
            sendEmail: true,
            APIVersion: "v2",
            paymentFor: "child",
            paymentMethodId: this.state.selectedCard.paymentMethodId,
            campId: this.state.eventId,
            parentId: this.state.parentId,
            childId: this.state.registerNewChild
              ? this.state.newChildId
              : this.state.selectedChild.value,
            teamId: this.state.team._id,
            paymentDoneFrom: "web",
          },
        });
      } else {
        response = await Server.request({
          url: "rushsoccer/stripe/interval/pay",
          method: "POST",
          data: {
            SPIEvent: true,
            sendEmail: true,
            APIVersion: "v2",
            interval: "month",
            paymentFor: "child",
            paymentMethodId: this.state.selectedCard.paymentMethodId,
            campId: this.state.eventId,
            parentId: this.state.parentId,
            childId: this.state.registerNewChild
              ? this.state.newChildId
              : this.state.selectedChild.value,
            teamId: this.state.team._id,
            paymentDoneFrom: "web",
          },
        });
      }
      if (response) {
        this.setState({
          showLoader: false,
          stripeCards: [],
          selectedCard: {},
          selectedChild: {},
          adult: {},
          player: {},
          disabledFields: false,
          playerDisabledFields: false,
          registerChild: false,
          showPayButton: false,
          registerFor: "parent",
          registerNewChild: false,
          newChildId: "",
          showPaymentPage: false,
          cvc: "",
          name: "",
          number: "",
          expiry: "",
          cardType: "",
          focus: "number",
          phoneOtp: "",
          phoneOtpSent: false,
          phoneOtpVerified: false,
          emailOtp: "",
          emailOtpSent: false,
          emailOtpVerified: false,
          fullPayment: true,
          selectedTabIndex: 0,
          installments: 0,
          installmentDates: [],
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.togglePaymentConfirmationModal();
        this.props.history.goBack();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  addCreditCard = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/addPaymentMethod",
        method: "POST",
        data: {
          type: "card",
          APIVersion: "v2",
          parentId: this.state.parentId,
          cvc: this.state.cvc,
          number: this.state.number,
          exp_year: this.state.expiry.length
            ? this.state.expiry.substring(2, 4)
            : "",
          exp_month: this.state.expiry.length
            ? this.state.expiry.substring(0, 2)
            : "",
          cardType: this.state.cardType,
          eventName: this.state.event.name,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          stripeCards:
            response.user.stripeCards && response.user.stripeCards.length
              ? response.user.stripeCards
              : [],
          selectedCard:
            response.user.stripeCards && response.user.stripeCards.length
              ? response.user.stripeCards[0]
              : {},
          cvc: "",
          name: "",
          number: "",
          expiry: "",
          cardType: "",
          focus: "number",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  sendOTP = async (event, sendOTPON) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let data = {
        sendOn: sendOTPON,
      };
      let setState = {
        showLoader: false,
      };
      switch (sendOTPON) {
        case "email":
          Object.assign(data, {
            email: this.state.adult.email,
          });
          Object.assign(setState, {
            emailOtpSent: true,
          });
          break;
        case "phone":
          Object.assign(data, {
            phone: `+1${this.state.adult.phone}`,
            username: `1${this.state.adult.phone}`,
          });
          Object.assign(setState, {
            phoneOtpSent: true,
          });
          break;
        default:
          break;
      }
      let response = await Server.staticTokenServerRequest(
        {
          url: "rushUser/createOTP",
          method: "POST",
          data,
        },
        true
      );
      if (response) {
        this.setState(setState);
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  verifyOTP = async (event, verifyOTPFor) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let data = {
        verifyFor: verifyOTPFor,
      };
      let setState = {
        showLoader: false,
      };
      switch (verifyOTPFor) {
        case "email":
          Object.assign(data, {
            otp: this.state.emailOtp,
            email: this.state.adult.email,
          });
          Object.assign(setState, {
            emailOtpVerified: true,
          });
          break;
        case "phone":
          Object.assign(data, {
            otp: this.state.phoneOtp,
            phone: `+1${this.state.adult.phone}`,
            username: `1${this.state.adult.phone}`,
          });
          Object.assign(setState, {
            phoneOtpVerified: true,
          });
          break;
        default:
          break;
      }
      let response = await Server.staticTokenServerRequest(
        {
          url: "rushUser/verifyOTP",
          method: "POST",
          data,
        },
        true
      );
      if (response && response.success) {
        this.setState(setState);
      } else {
        this.setState({
          showLoader: false,
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "error",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getImageUrl = (keyName, type) => {
    let imageUrl;
    switch (type) {
      case "adult":
        if (keyName === "photo1") {
          let file = this.state.adult.files.find(
            (file) => file.name === "photo"
          );
          imageUrl = file.url;
        } else {
          let file = this.state.adult.files.find(
            (file) => file.name === keyName
          );
          imageUrl = file.url;
        }
        break;
      case "player":
        let file = this.state.player.files.find(
          (file) => file.name === keyName
        );
        imageUrl = file.url;
        break;
      default:
        break;
    }
    return imageUrl;
  };

  installmentDates = (key) => {
    let dates =
      this.state.installmentDates.length > 0 ? this.state.installmentDates : [];
    if (key === "add") {
      if (this.state.installmentDates.length !== this.state.installments) {
        let Start =
          this.state.installmentDates.length === 0
            ? 1
            : this.state.installmentDates.length + 1;
        for (let index = Start; index <= this.state.installments; index++) {
          dates.push({ price: 0, date: "", installmentNumber: index });
        }
      }
    } else if (key === "remove") {
      for (
        let index1 = this.state.installments + 1;
        index1 <= this.state.installmentDates.length;
        index1++
      ) {
        dates = dates.filter((date) => date.installmentNumber !== index1);
      }
    }
    this.setState({ installmentDates: dates });
  };

  formatCreditCardNumber = (number) =>
    `**** **** **** ${
      number ? number.substr(number.length - 4, number.length) : "****"
    }`;

  toggleVerificationModal = () => {
    this.setState({
      verificationModal: !this.state.verificationModal,
    });
  };

  togglePaymentConfirmationModal = () => {
    this.setState({
      paymentConfirmationModal: !this.state.paymentConfirmationModal,
    });
  };

  render() {
    return (
      <Fragment>
        <PageSpinner showLoader={this.state.showLoader} />
        <Navbar
          light
          expand
          className={bem.b("#17517B")}
          style={{
            backgroundColor: "#17517B",
            borderBottom: 0,
            marginBottom: 0,
          }}
        >
          <div
            style={{
              color: "white",
              margin: "auto",
            }}
          >
            <h1
              style={{
                margin: "auto",
                fontWeight: "bold",
              }}
            >
              RushSoccer
            </h1>
          </div>
        </Navbar>
        {!this.state.registrationFormPage ? (
          this.state.defaultPage ? (
            <Container>
              <div
                className="login-form"
                style={{
                  marginTop: "20px",
                  maxWidth: "unset",
                }}
              >
                <Col
                  style={{
                    borderBottom: "3px solid #e4e5e6",
                    marginBottom: "10px",
                  }}
                >
                  <h2>Choose what you are registering for</h2>
                </Col>
                <Row
                  style={{
                    borderBottom: "3px solid #e4e5e6",
                    margin: "0px 0px 10px 0px",
                  }}
                >
                  <Col xl={6} lg={6} md={12} sm={12}>
                    <FormGroup>
                      <Label style={{ fontWeight: "bold" }}>
                        I AM REGISTERING FOR :
                      </Label>
                      <CustomInput
                        className="removeMargin"
                        type="checkbox"
                        id="localRushClub"
                        label="My Local Rush Club"
                        checked={!this.state.SPIRegistration}
                        onChange={() =>
                          this.setState({
                            SPIRegistration: false,
                          })
                        }
                      />
                      <CustomInput
                        type="checkbox"
                        id="SPI"
                        label="A Rush National Program"
                        checked={this.state.SPIRegistration}
                        onChange={() =>
                          this.setState({
                            clubId: this.state.SPIClub._id,
                            scoccerClub: this.state.SPIClub.name,
                            SPIRegistration: true,
                          })
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row style={{ padding: "0px 15px" }}>
                  <Col xl={6} lg={6} md={12} sm={12}>
                    <Label>First Name</Label>
                    <FormGroup>
                      <Input
                        value={this.state.firstName}
                        onChange={(event) =>
                          this.setState({
                            firstName: event.target.value,
                          })
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row style={{ padding: "0px 15px" }}>
                  <Col xl={6} lg={6} md={12} sm={12}>
                    <Label>Last Name</Label>
                    <FormGroup>
                      <Input
                        value={this.state.lastName}
                        onChange={(event) =>
                          this.setState({
                            lastName: event.target.value,
                          })
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row
                  style={{
                    borderTop: "3px solid #e4e5e6",
                    margin: "0px 0px 10px 0px",
                    paddingTop: "10px",
                  }}
                >
                  <Col
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <Button
                      onClick={() =>
                        this.setState({
                          defaultPage: false,
                        })
                      }
                    >
                      Continue
                    </Button>
                  </Col>
                </Row>
              </div>
            </Container>
          ) : this.state.SPIRegistration ? (
            this.state.SPIParentCampPage ? (
              <Container>
                <div
                  className="login-form"
                  style={{
                    marginTop: "20px",
                    maxWidth: "unset",
                  }}
                >
                  <Col
                    style={{
                      borderBottom: "3px solid #e4e5e6",
                      marginBottom: "10px",
                    }}
                  >
                    <h2>
                      PICK WHICH RUSH NATIONAL PROGRAM YOU WANT TO REGISTER FOR
                    </h2>
                  </Col>
                  <Row
                    style={{
                      margin: "0px 0px 10px 0px",
                    }}
                  >
                    <Col xl={6} lg={6} md={12} sm={12}>
                      <FormGroup>
                        <Label style={{ fontWeight: "bold" }}>
                          I AM REGISTERING FOR :
                        </Label>
                        {this.state.SPIParentCamps &&
                        this.state.SPIParentCamps.length
                          ? this.state.SPIParentCamps.map(
                              (SPIParentCamp, index) => (
                                <CustomInput
                                  className="removeMargin"
                                  key={index}
                                  style={{ marginLeft: "0px !important" }}
                                  type="checkbox"
                                  id={`SPIParentCamp${index}`}
                                  label={SPIParentCamp.name}
                                  checked={
                                    this.state.selectedSPIParentCampIndex ===
                                    index
                                  }
                                  onChange={() =>
                                    this.setState({
                                      SPICamps: SPIParentCamp.camps,
                                      selectedSPIParentCamp: SPIParentCamp,
                                      selectedSPIParentCampIndex: index,
                                    })
                                  }
                                />
                              )
                            )
                          : null}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row
                    style={{
                      borderTop: "3px solid #e4e5e6",
                      margin: "0px 0px 10px 0px",
                      paddingTop: "10px",
                    }}
                  >
                    <Col
                      style={{
                        textAlign: "center",
                      }}
                    >
                      <Button
                        disabled={!this.state.selectedSPIParentCamp._id}
                        onClick={() =>
                          this.setState({
                            SPIParentCampPage: false,
                          })
                        }
                      >
                        Continue
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Container>
            ) : (
              <Container>
                <div
                  className="login-form"
                  style={{
                    marginTop: "20px",
                    maxWidth: "unset",
                  }}
                >
                  <Col
                    style={{
                      borderBottom: "3px solid #e4e5e6",
                      marginBottom: "10px",
                    }}
                  >
                    <h2>
                      PICK WHICH RUSH NATIONAL PROGRAM YOU WANT TO REGISTER FOR
                    </h2>
                  </Col>
                  <Row
                    style={{
                      margin: "0px 0px 10px 0px",
                    }}
                  >
                    <Col xl={6} lg={6} md={12} sm={12}>
                      <FormGroup>
                        <Label style={{ fontWeight: "bold" }}>
                          I AM REGISTERING FOR :
                        </Label>
                        {this.state.SPICamps && this.state.SPICamps.length
                          ? this.state.SPICamps.map((SPICamp, index) => (
                              <CustomInput
                                className="removeMargin"
                                key={index}
                                style={{ marginLeft: "0px !important" }}
                                type="checkbox"
                                id={`SPICamp${index}`}
                                label={SPICamp.name}
                                checked={
                                  this.state.selectedSPICampIndex === index
                                }
                                onChange={() =>
                                  this.setState({
                                    selectedSPICamp: SPICamp,
                                    selectedSPICampIndex: index,
                                  })
                                }
                              />
                            ))
                          : null}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row
                    style={{
                      borderTop: "3px solid #e4e5e6",
                      margin: "0px 0px 10px 0px",
                      paddingTop: "10px",
                    }}
                  >
                    <Col
                      style={{
                        textAlign: "center",
                      }}
                    >
                      <Button
                        disabled={!this.state.selectedSPICamp._id}
                        onClick={() => this.registerForSPI()}
                      >
                        Register
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Container>
            )
          ) : this.state.clubSelectPage ? (
            <Container>
              <div
                className="login-form"
                style={{
                  marginTop: "20px",
                  maxWidth: "unset",
                }}
              >
                <Col
                  style={{
                    borderBottom: "3px solid #e4e5e6",
                    marginBottom: "10px",
                  }}
                >
                  <h2>Choose what you are registering for</h2>
                </Col>
                <Row
                  style={{
                    margin: "0px 0px 10px 0px",
                  }}
                >
                  <Col xl={6} lg={6} md={12} sm={12}>
                    <FormGroup>
                      <Label style={{ fontWeight: "bold" }}>
                        I AM REGISTERING FOR :
                      </Label>
                      {this.state.clubs && this.state.clubs.length
                        ? this.state.clubs.map((club, index) => (
                            <CustomInput
                              className="removeMargin"
                              key={index}
                              style={{ marginLeft: "0px !important" }}
                              type="checkbox"
                              id={`localRushClub${index}`}
                              label={club.name}
                              checked={this.state.selectedClubIndex === index}
                              onChange={() =>
                                this.setState({
                                  selectedClub: club,
                                  selectedClubIndex: index,
                                })
                              }
                            />
                          ))
                        : null}
                    </FormGroup>
                  </Col>
                </Row>
                <Row
                  style={{
                    borderTop: "3px solid #e4e5e6",
                    margin: "0px 0px 10px 0px",
                    paddingTop: "10px",
                  }}
                >
                  <Col
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <Button
                      disabled={!this.state.selectedClub._id}
                      onClick={() => this.setNameAPI()}
                    >
                      Continue
                    </Button>
                  </Col>
                </Row>
              </div>
            </Container>
          ) : (
            <Container>
              <div
                className="login-form"
                style={{
                  marginTop: "20px",
                  maxWidth: "unset",
                }}
              >
                <Col
                  style={{
                    borderBottom: "3px solid #e4e5e6",
                    marginBottom: "10px",
                  }}
                >
                  <h2>Choose team and event you are registering for</h2>
                </Col>
                <Row
                  style={{
                    margin: "0px 0px 10px 0px",
                  }}
                >
                  <Col xl={6} lg={6} md={12} sm={12}>
                    <FormGroup>
                      <Label style={{ fontWeight: "bold" }}>
                        Select Team :
                      </Label>
                      <Select
                        isSearchable={true}
                        value={this.state.selectedTeam}
                        options={this.state.allTeamsOptions}
                        onChange={(result) => this.getCamps(result)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row
                  style={{
                    margin: "0px 0px 10px 0px",
                  }}
                >
                  <Col xl={6} lg={6} md={12} sm={12}>
                    <FormGroup>
                      <Label style={{ fontWeight: "bold" }}>
                        Select Event :
                      </Label>
                      <Select
                        isSearchable={true}
                        value={this.state.selectedCamp}
                        options={this.state.allCampsOptions}
                        onChange={(result) => {
                          let camp = this.state.allCamps.find(
                            (camp) => camp._id === result.value
                          );
                          this.setState({
                            event: camp ? camp : {},
                            eventId: camp ? camp._id : {},
                            selectedCamp: result,
                          });
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row
                  style={{
                    borderTop: "3px solid #e4e5e6",
                    margin: "0px 0px 10px 0px",
                    paddingTop: "10px",
                  }}
                >
                  <Col
                    style={{
                      textAlign: "center",
                    }}
                  >
                    <Button
                      disabled={
                        !this.state.selectedTeam.value ||
                        !this.state.selectedCamp.value
                      }
                      onClick={() => this.getProcessingFees()}
                    >
                      Continue
                    </Button>
                  </Col>
                </Row>
              </div>
            </Container>
          )
        ) : null}
        {this.state.registrationFormPage ? (
          this.state.showPaymentPage ? (
            <Container>
              <div
                className="login-form"
                style={{
                  margin: "20px 0px",
                  maxWidth: "unset",
                }}
              >
                <Col
                  style={{
                    borderBottom: "3px solid #e4e5e6",
                    marginBottom: "10px",
                  }}
                >
                  <h2>Payment for event</h2>
                </Col>
                <Row style={{ padding: "0px 15px" }}>
                  <Col xl={6} lg={6} md={12} sm={12}>
                    <Label>Team Name</Label>
                    <FormGroup>
                      <Input
                        disabled
                        value={this.state.team.name ? this.state.team.name : ""}
                      />
                    </FormGroup>
                  </Col>
                  <Col xl={6} lg={6} md={12} sm={12}>
                    <Label>Event</Label>
                    <FormGroup>
                      <Input
                        disabled
                        value={
                          this.state.event.name ? this.state.event.name : ""
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row style={{ padding: "0px 15px" }}>
                  <Col xl={6} lg={6} md={12} sm={12}>
                    <Label>Parent Name</Label>
                    <FormGroup>
                      <Input
                        disabled
                        value={
                          this.state.adult.firstName
                            ? `${this.state.adult.firstName} ${this.state.adult.lastName}`
                            : ""
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col xl={6} lg={6} md={12} sm={12}>
                    <Label>Child Name</Label>
                    <FormGroup>
                      <Input
                        disabled
                        value={
                          this.state.player.firstName
                            ? `${this.state.player.firstName} ${this.state.player.lastName}`
                            : ""
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Col
                  style={{
                    borderTop: "3px solid #e4e5e6",
                    borderBottom: "3px solid #e4e5e6",
                    marginBottom: "10px",
                    paddingTop: "10px",
                  }}
                >
                  <h2>Add Credit Card</h2>
                </Col>
                <Form className="form" onSubmit={this.addCreditCard}>
                  <Row style={{ padding: "0px 15px" }}>
                    <Col
                      style={{ margin: "auto" }}
                      xl={6}
                      lg={6}
                      md={12}
                      sm={12}
                    >
                      <Cards
                        cvc={this.state.cvc}
                        expiry={this.state.expiry}
                        focused={this.state.focus}
                        name={this.state.name}
                        number={this.state.number}
                        callback={(event) => {
                          this.setState({ cardType: event.issuer });
                        }}
                      />
                    </Col>
                    <Col className="mt-3" xl={6} lg={6} md={12} sm={12}>
                      <>
                        <Label>Card Number</Label>
                        <FormGroup>
                          <Input
                            id="number"
                            name="number"
                            type="text"
                            maxLength="16"
                            value={this.state.number}
                            onChange={(event) =>
                              this.setState({
                                number: event.target.value,
                                focus: "number",
                              })
                            }
                            placeholder="CARD NUMBER"
                            required
                          />
                        </FormGroup>
                      </>
                      <>
                        <Label>Card Name</Label>
                        <FormGroup>
                          <Input
                            id="name"
                            name="name"
                            type="text"
                            value={this.state.name}
                            onChange={(event) =>
                              this.setState({
                                name: event.target.value,
                                focus: "name",
                              })
                            }
                            placeholder="CARD NAME"
                            required
                          />
                        </FormGroup>
                      </>
                      <Row>
                        <Col xl={6} lg={6} md={12} sm={12}>
                          <Label>Card Expiration Date</Label>
                          <FormGroup>
                            <Input
                              id="expiry"
                              name="expiry"
                              type="text"
                              maxLength="4"
                              value={this.state.expiry}
                              onChange={(event) =>
                                this.setState({
                                  expiry: event.target.value,
                                  focus: "expiry",
                                })
                              }
                              placeholder="MM/YY"
                              required
                            />
                          </FormGroup>
                        </Col>
                        <Col xl={6} lg={6} md={12} sm={12}>
                          <Label>CVC</Label>
                          <FormGroup>
                            <Input
                              id="cvc"
                              name="cvc"
                              type="text"
                              maxLength="4"
                              value={this.state.cvc}
                              onChange={(event) =>
                                this.setState({
                                  cvc: event.target.value,
                                  focus: "cvc",
                                })
                              }
                              placeholder="CVC"
                              required
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <>
                        <FormGroup>
                          <Button type="submit" onClick={() => {}}>
                            Add Credit Card
                          </Button>
                        </FormGroup>
                      </>
                    </Col>
                  </Row>
                </Form>
                <Row>
                  <Col>
                    <Table striped hover responsive>
                      <thead>
                        <tr>
                          <th className={"text-center"}>Select Card</th>
                          <th className={"text-center"}>Card Number</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.stripeCards.length ? (
                          this.state.stripeCards.map((card, index) => (
                            <tr key={index}>
                              <td className={"text-center"}>
                                <Input
                                  type="checkbox"
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    marginTop: "0px",
                                  }}
                                  onClick={() =>
                                    this.setState({ selectedCard: card })
                                  }
                                  checked={
                                    this.state.selectedCard._id === card._id
                                  }
                                ></Input>
                              </td>
                              <td className={"text-center"}>
                                {card.number
                                  ? this.formatCreditCardNumber(card.number)
                                  : "-"}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="2" className="text-center">
                              No cards found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
                <Col
                  style={{
                    padding: "5px 0px",
                    borderTop: "3px solid #e4e5e6",
                  }}
                ></Col>
                <Col>
                  <Table striped hover responsive>
                    <thead>
                      <tr>
                        <th colSpan="2" className={"text-center"}>
                          Event Details
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className={"text-center"}>Event Name</td>
                        <td className={"text-center"}>
                          {this.state.event.name ? this.state.event.name : "-"}
                        </td>
                      </tr>
                      <tr>
                        <td className={"text-center"}>
                          <CustomInput
                            id="fullpayment"
                            type="radio"
                            label="Full Payment"
                            checked={this.state.fullPayment}
                            name="payment"
                            onClick={() =>
                              this.setState({
                                fullPayment: true,
                              })
                            }
                          />
                        </td>
                        <td className={"text-center"}>
                          <CustomInput
                            id="installmentpayment"
                            type="radio"
                            label="Installment payment"
                            checked={!this.state.fullPayment}
                            name="payment"
                            onClick={() =>
                              this.setState({
                                fullPayment: false,
                              })
                            }
                          />
                        </td>
                      </tr>
                      {this.state.fullPayment ? (
                        <>
                          <tr>
                            <td className={"text-center"}>Price</td>
                            <td className={"text-center"}>
                              {this.state.eventPriceDetails.fullPayment
                                ? this.state.eventPriceDetails.fullPayment.price.toFixed(
                                    2
                                  )
                                : 0}
                            </td>
                          </tr>
                          {/* <tr>
                            <td className={"text-center"}>Credit Amount</td>
                            <td className={"text-center"}>
                              {this.state.eventPriceDetails.fullPayment
                                ? this.state.eventPriceDetails.fullPayment.creditAmount.toFixed(
                                  2
                                )
                                : 0}
                            </td>
                          </tr>
                          <tr>
                            <td className={"text-center"}>Past Due</td>
                            <td className={"text-center"}>
                              {this.state.eventPriceDetails.fullPayment
                                ? this.state.eventPriceDetails.fullPayment.dueAmount.toFixed(
                                  2
                                )
                                : 0}
                            </td>
                          </tr> */}
                          <tr>
                            <td className={"text-center"}>Processing Fee</td>
                            <td className={"text-center"}>
                              {this.state.eventPriceDetails.fullPayment
                                ? this.state.eventPriceDetails.fullPayment.processingFee.toFixed(
                                    2
                                  )
                                : 0}
                            </td>
                          </tr>
                          <tr>
                            <td className={"text-center"}>Total Price</td>
                            <td className={"text-center"}>
                              $
                              {this.state.eventPriceDetails.fullPayment
                                ? this.state.eventPriceDetails.fullPayment.totalPrice.toFixed(
                                    2
                                  )
                                : 0}
                            </td>
                          </tr>
                        </>
                      ) : this.state.eventPriceDetails.installments &&
                        this.state.eventPriceDetails.installments.length ? (
                        <tr>
                          <td colSpan="2">
                            <Table striped hover responsive>
                              <thead>
                                <tr>
                                  <th className={"text-center"}>
                                    Installment Number
                                  </th>
                                  <th className={"text-center"}>Price</th>
                                  <th className={"text-center"}>Due Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.eventPriceDetails.installments.map(
                                  (installment, index) => (
                                    <tr key={index}>
                                      <td className={"text-center"}>
                                        {installment.installmentNumber
                                          ? installment.installmentNumber
                                          : "-"}
                                      </td>
                                      <td className={"text-center"}>
                                        $
                                        {installment.totalPrice
                                          ? installment.totalPrice.toFixed(2)
                                          : "0.00"}
                                      </td>
                                      <td className={"text-center"}>
                                        {installment.dueDate
                                          ? moment
                                              .utc(installment.dueDate)
                                              .format("LL")
                                          : "-"}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </Table>
                          </td>
                        </tr>
                      ) : (
                        <tr>
                          <td colSpan="2" className={"text-center"}>
                            No installment payment
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </Col>
                <Col
                  style={{
                    padding: "5px 0px",
                    borderTop: "3px solid #e4e5e6",
                  }}
                ></Col>
                <Col
                  style={{
                    textAlign: "center",
                  }}
                >
                  <Button
                    disabled={
                      !this.state.fullPayment &&
                      (this.state.eventPriceDetails.installments &&
                      this.state.eventPriceDetails.installments.length
                        ? false
                        : true)
                    }
                    type="submit"
                    className="ml-2"
                    onClick={() => this.togglePaymentConfirmationModal()}
                  >
                    Pay
                  </Button>
                </Col>
              </div>
              {this.state.paymentConfirmationModal ? (
                <Modal
                  isOpen={this.state.paymentConfirmationModal}
                  toggle={(event) => this.togglePaymentConfirmationModal()}
                  className="modal-md"
                >
                  <ModalHeader
                    style={{
                      background: "#f8f9fa",
                    }}
                    toggle={(event) => this.togglePaymentConfirmationModal()}
                  >
                    Confirmantion
                  </ModalHeader>
                  <ModalBody
                    style={{
                      background: "#f8f9fa",
                    }}
                  >
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label>Are you sure you want to pay?</Label>
                        </FormGroup>
                      </Col>
                    </Row>
                  </ModalBody>
                  <ModalFooter
                    style={{
                      background: "#f8f9fa",
                    }}
                  >
                    <Form className="form" onSubmit={this.payForEvent}>
                      <Button type="submit">Pay</Button>
                    </Form>
                    <Button
                      onClick={() => this.togglePaymentConfirmationModal()}
                    >
                      Cancel
                    </Button>{" "}
                  </ModalFooter>
                </Modal>
              ) : null}
            </Container>
          ) : (
            <>
              {this.state.registerFormFieldsAdult.length &&
              this.state.registerFormFieldsPlayers.length ? (
                <Container>
                  <div
                    className="login-form"
                    style={{
                      margin: "20px 0px",
                      maxWidth: "unset",
                    }}
                  >
                    <Col
                      style={{
                        borderBottom: "3px solid #e4e5e6",
                        marginBottom: "10px",
                      }}
                    >
                      <h2>Registration Form</h2>
                    </Col>
                    <Form className="form" onSubmit={this.onSubmit}>
                      <Tabs
                        style={{ width: "100%" }}
                        onSelect={(index) =>
                          this.setState({ selectedTabIndex: index })
                        }
                        selectedIndex={this.state.selectedTabIndex}
                      >
                        <TabList>
                          <Tab>Register Parent</Tab>
                          {this.state.registerChild && (
                            <Tab>Register Player</Tab>
                          )}
                        </TabList>
                        <TabPanel>
                          {this.state.registerFormFieldsAdult.map(
                            (registerFormField, index) => (
                              <Col key={index}>
                                <FormGroup>
                                  {registerFormField.inputType === "text" && (
                                    <>
                                      <Label>
                                        {registerFormField.placeholder}
                                        {registerFormField.required && (
                                          <span
                                            style={{
                                              color: "red",
                                              marginLeft: "5px",
                                            }}
                                          >
                                            *
                                          </span>
                                        )}
                                      </Label>
                                      <div style={{ display: "flex" }}>
                                        <Input
                                          disabled={
                                            this.state.disabledFields ||
                                            registerFormField.keyName ===
                                              "email"
                                              ? this.state.emailOtpVerified
                                              : false
                                          }
                                          id={index}
                                          name={registerFormField.name}
                                          type="text"
                                          value={
                                            this.state.adult[
                                              registerFormField.keyName
                                            ] || ""
                                          }
                                          onChange={(event) =>
                                            this.updateState(
                                              "adult",
                                              registerFormField.keyName,
                                              event.target.value
                                            )
                                          }
                                          placeholder={
                                            registerFormField.placeholder
                                          }
                                          required={registerFormField.required}
                                        />
                                        {registerFormField.keyName ===
                                          "email" && (
                                          <>
                                            {this.state.emailOtpVerified &&
                                            !this.state.disabledFields ? (
                                              <>
                                                <GoVerified
                                                  size="20px"
                                                  style={{
                                                    margin:
                                                      "auto auto auto 10px",
                                                    outline: " unset",
                                                    color: "green",
                                                  }}
                                                  id="verifiedEmailTooltip"
                                                  onMouseOver={() =>
                                                    this.setState({
                                                      verifiedEmailTooltip: true,
                                                    })
                                                  }
                                                  onMouseOut={() =>
                                                    this.setState({
                                                      verifiedEmailTooltip: false,
                                                    })
                                                  }
                                                />
                                                <MdEdit
                                                  size="20px"
                                                  style={{
                                                    cursor: "pointer",
                                                    margin:
                                                      "auto auto auto 10px",
                                                    outline: " unset",
                                                  }}
                                                  onClick={() =>
                                                    this.setState({
                                                      emailOtp: "",
                                                      emailOtpSent: false,
                                                      emailOtpVerified: false,
                                                    })
                                                  }
                                                />
                                                <Tooltip
                                                  placement="bottom"
                                                  isOpen={
                                                    this.state
                                                      .verifiedEmailTooltip
                                                  }
                                                  target="verifiedEmailTooltip"
                                                  toggle={() => {}}
                                                >
                                                  Email Verified
                                                </Tooltip>
                                              </>
                                            ) : !this.state.disabledFields ? (
                                              <>
                                                <GoUnverified
                                                  size="20px"
                                                  id="unverifiedEmailTooltip"
                                                  style={{
                                                    margin:
                                                      "auto auto auto 10px",
                                                    outline: " unset",
                                                  }}
                                                  onMouseOver={() =>
                                                    this.setState({
                                                      unverifiedEmailTooltip: true,
                                                    })
                                                  }
                                                  onMouseOut={() =>
                                                    this.setState({
                                                      unverifiedEmailTooltip: false,
                                                    })
                                                  }
                                                />
                                                <Tooltip
                                                  placement="bottom"
                                                  isOpen={
                                                    this.state
                                                      .unverifiedEmailTooltip
                                                  }
                                                  target="unverifiedEmailTooltip"
                                                  toggle={() => {}}
                                                >
                                                  Email Unverified
                                                </Tooltip>
                                              </>
                                            ) : null}
                                          </>
                                        )}
                                      </div>
                                    </>
                                  )}
                                  {registerFormField.keyName === "email" &&
                                    !this.state.emailOtpVerified &&
                                    this.state.adult[
                                      registerFormField.keyName
                                    ] && (
                                      <>
                                        {this.state.emailOtpSent ? (
                                          <>
                                            <FormGroup className="mt-3">
                                              <Label>Verify Email</Label>
                                              <OtpInput
                                                className="otpInput d-flex justify-content-center"
                                                inputStyle={{
                                                  color: "#17517b",
                                                  width: "3rem",
                                                  height: "3rem",
                                                  margin: "0 1rem",
                                                  fontSize: "2rem",
                                                  borderRadius: "4px",
                                                  border:
                                                    "1px solid rgba(0,0,0,0.3)",
                                                  outlineColor: "#17517b",
                                                }}
                                                isInputNum={true}
                                                value={this.state.emailOtp}
                                                onChange={(value) =>
                                                  this.setState({
                                                    emailOtp: value,
                                                  })
                                                }
                                                numInputs={4}
                                                separator={<span>-</span>}
                                              />
                                            </FormGroup>
                                            <Button
                                              onClick={(event) =>
                                                this.verifyOTP(event, "email")
                                              }
                                            >
                                              Verify OTP
                                            </Button>
                                            <Button
                                              className="ml-2"
                                              onClick={(event) =>
                                                this.sendOTP(event, "email")
                                              }
                                            >
                                              Resend OTP
                                            </Button>
                                          </>
                                        ) : (
                                          <Button
                                            className="mt-3"
                                            onClick={(event) =>
                                              this.sendOTP(event, "email")
                                            }
                                          >
                                            Send OTP
                                          </Button>
                                        )}
                                      </>
                                    )}
                                  {registerFormField.inputType === "number" && (
                                    <>
                                      <Label>
                                        {registerFormField.placeholder}
                                        {registerFormField.required && (
                                          <span
                                            style={{
                                              color: "red",
                                              marginLeft: "5px",
                                            }}
                                          >
                                            *
                                          </span>
                                        )}
                                      </Label>
                                      <div style={{ display: "flex" }}>
                                        {registerFormField.keyName ===
                                        "phone" ? (
                                          <Input
                                            id={index}
                                            disabled
                                            type="number"
                                            value={
                                              this.state.adult[
                                                registerFormField.keyName
                                              ] || ""
                                            }
                                          />
                                        ) : (
                                          <Input
                                            id={index}
                                            disabled={
                                              this.state.disabledFields ||
                                              registerFormField.keyName ===
                                                "phone"
                                                ? this.state.phoneOtpVerified
                                                : false
                                            }
                                            name={registerFormField.name}
                                            type="number"
                                            value={
                                              this.state.adult[
                                                registerFormField.keyName
                                              ] || ""
                                            }
                                            onChange={(event) =>
                                              event.target.value > -1 &&
                                              this.updateState(
                                                "adult",
                                                registerFormField.keyName,
                                                event.target.value
                                              )
                                            }
                                            placeholder={
                                              registerFormField.placeholder
                                            }
                                            required={
                                              registerFormField.required
                                            }
                                          />
                                        )}
                                        {registerFormField.keyName ===
                                          "phone" && (
                                          <>
                                            {this.state.phoneOtpVerified &&
                                            !this.state.disabledFields ? (
                                              <>
                                                <GoVerified
                                                  size="20px"
                                                  style={{
                                                    margin:
                                                      "auto auto auto 10px",
                                                    outline: " unset",
                                                    color: "green",
                                                  }}
                                                  id="verifiedPhoneTooltip"
                                                  onMouseOver={() =>
                                                    this.setState({
                                                      verifiedPhoneTooltip: true,
                                                    })
                                                  }
                                                  onMouseOut={() =>
                                                    this.setState({
                                                      verifiedPhoneTooltip: false,
                                                    })
                                                  }
                                                />
                                                {/* <MdEdit
                                                    size="20px"
                                                    style={{
                                                      cursor: "pointer",
                                                      margin:
                                                        "auto auto auto 10px",
                                                      outline: " unset",
                                                    }}
                                                    onClick={() =>
                                                      this.setState({
                                                        phoneOtp: "",
                                                        phoneOtpSent: false,
                                                        phoneOtpVerified: false,
                                                      })
                                                    }
                                                  /> */}
                                                <Tooltip
                                                  placement="bottom"
                                                  isOpen={
                                                    this.state
                                                      .verifiedPhoneTooltip
                                                  }
                                                  target="verifiedPhoneTooltip"
                                                  toggle={() => {}}
                                                >
                                                  Phone Verified
                                                </Tooltip>
                                              </>
                                            ) : !this.state.disabledFields ? (
                                              <>
                                                <GoUnverified
                                                  size="20px"
                                                  id="unverifiedPhoneTooltip"
                                                  style={{
                                                    margin:
                                                      "auto auto auto 10px",
                                                    outline: " unset",
                                                  }}
                                                  onMouseOver={() =>
                                                    this.setState({
                                                      unverifiedPhoneTooltip: true,
                                                    })
                                                  }
                                                  onMouseOut={() =>
                                                    this.setState({
                                                      unverifiedPhoneTooltip: false,
                                                    })
                                                  }
                                                />
                                                <Tooltip
                                                  placement="bottom"
                                                  isOpen={
                                                    this.state
                                                      .unverifiedPhoneTooltip
                                                  }
                                                  target="unverifiedPhoneTooltip"
                                                  toggle={() => {}}
                                                >
                                                  Phone Unverified
                                                </Tooltip>
                                              </>
                                            ) : null}
                                          </>
                                        )}
                                      </div>
                                    </>
                                  )}
                                  {registerFormField.keyName === "phone" &&
                                    !this.state.phoneOtpVerified &&
                                    this.state.adult[
                                      registerFormField.keyName
                                    ] && (
                                      <>
                                        {this.state.phoneOtpSent ? (
                                          <>
                                            <FormGroup className="mt-3">
                                              <Label>Verify Phone</Label>
                                              <OtpInput
                                                className="otpInput d-flex justify-content-center"
                                                inputStyle={{
                                                  color: "#17517b",
                                                  width: "3rem",
                                                  height: "3rem",
                                                  margin: "0 1rem",
                                                  fontSize: "2rem",
                                                  borderRadius: "4px",
                                                  border:
                                                    "1px solid rgba(0,0,0,0.3)",
                                                  outlineColor: "#17517b",
                                                }}
                                                isInputNum={true}
                                                value={this.state.phoneOtp}
                                                onChange={(value) =>
                                                  this.setState({
                                                    phoneOtp: value,
                                                  })
                                                }
                                                numInputs={4}
                                                separator={<span>-</span>}
                                              />
                                            </FormGroup>
                                            <Button
                                              onClick={(event) =>
                                                this.verifyOTP(event, "phone")
                                              }
                                            >
                                              Verify OTP
                                            </Button>
                                            <Button
                                              className="ml-2"
                                              onClick={(event) =>
                                                this.sendOTP(event, "phone")
                                              }
                                            >
                                              Resend OTP
                                            </Button>
                                          </>
                                        ) : (
                                          <Button
                                            className="mt-3"
                                            onClick={(event) =>
                                              this.sendOTP(event, "phone")
                                            }
                                          >
                                            Send OTP
                                          </Button>
                                        )}
                                      </>
                                    )}
                                  {registerFormField.inputType ===
                                    "datepicker" && (
                                    <>
                                      <Label>
                                        {registerFormField.placeholder}
                                        {registerFormField.required && (
                                          <span
                                            style={{
                                              color: "red",
                                              marginLeft: "5px",
                                            }}
                                          >
                                            *
                                          </span>
                                        )}
                                      </Label>
                                      <Input
                                        id={index}
                                        disabled={this.state.disabledFields}
                                        name={registerFormField.name}
                                        type="date"
                                        value={
                                          this.state.adult[
                                            registerFormField.keyName
                                          ] || ""
                                        }
                                        onChange={(event) =>
                                          this.updateState(
                                            "adult",
                                            registerFormField.keyName,
                                            event.target.value
                                          )
                                        }
                                        placeholder={
                                          registerFormField.placeholder
                                        }
                                        required={registerFormField.required}
                                      />
                                    </>
                                  )}
                                  {registerFormField.inputType ===
                                    "dropdown" && (
                                    <>
                                      <Label>
                                        {registerFormField.placeholder}
                                        {registerFormField.required && (
                                          <span
                                            style={{
                                              color: "red",
                                              marginLeft: "5px",
                                            }}
                                          >
                                            *
                                          </span>
                                        )}
                                      </Label>
                                      <Input
                                        disabled={this.state.disabledFields}
                                        type="select"
                                        name={registerFormField.name}
                                        value={
                                          this.state.adult[
                                            registerFormField.keyName
                                          ] || "default"
                                        }
                                        required={registerFormField.required}
                                        onChange={(event) =>
                                          this.updateState(
                                            "adult",
                                            registerFormField.keyName,
                                            event.target.value
                                          )
                                        }
                                      >
                                        <option value="default" disabled>
                                          Select the value
                                        </option>
                                        {registerFormField.values.map(
                                          (value, index) => (
                                            <option key={index} value={value}>
                                              {value}
                                            </option>
                                          )
                                        )}
                                      </Input>
                                    </>
                                  )}
                                  {registerFormField.inputType ===
                                    "fileupload" && (
                                    <>
                                      <Label>
                                        {registerFormField.placeholder}
                                        {registerFormField.required && (
                                          <span
                                            style={{
                                              color: "red",
                                              marginLeft: "5px",
                                            }}
                                          >
                                            *
                                          </span>
                                        )}
                                      </Label>
                                      <div>
                                        {this.state.disabledFields ? (
                                          <CardImg
                                            style={{ width: "25%" }}
                                            key={index}
                                            src={this.getImageUrl(
                                              registerFormField.keyName,
                                              "adult"
                                            )}
                                            alt=""
                                          />
                                        ) : (
                                          <>
                                            <Label
                                              htmlFor={registerFormField._id}
                                            >
                                              <span className="btn btn-secondary">
                                                Select File
                                              </span>
                                              <span
                                                style={{ marginLeft: "5px" }}
                                              >
                                                {
                                                  this.state.adult[
                                                    `${registerFormField.keyName}FileName`
                                                  ]
                                                }
                                              </span>
                                            </Label>
                                            <input
                                              disabled={
                                                this.state.disabledFields
                                              }
                                              style={{ display: "none" }}
                                              id={registerFormField._id}
                                              type="file"
                                              onChange={(event) =>
                                                this.handleChange(
                                                  "adult",
                                                  registerFormField.keyName,
                                                  event
                                                )
                                              }
                                            />
                                          </>
                                        )}
                                      </div>
                                    </>
                                  )}
                                </FormGroup>
                              </Col>
                            )
                          )}
                          {this.state.wavierFormFieldsAdult.length &&
                          !this.state.disabledFields ? (
                            <>
                              <Col
                                style={{
                                  textAlign: "center",
                                  padding: "10px 0px",
                                  borderTop: "3px solid #e4e5e6",
                                }}
                              >
                                <h3>Waviers For Adult</h3>
                              </Col>
                              {this.state.wavierFormFieldsAdult.map(
                                (wavierFormField, index) => (
                                  <Col key={index}>
                                    <FormGroup>
                                      {wavierFormField.inputType ===
                                        "waviers" && (
                                        <>
                                          <div className="d-flex">
                                            <CustomInput
                                              type="checkbox"
                                              id={wavierFormField._id}
                                              label={
                                                wavierFormField.placeholder
                                              }
                                              required={
                                                wavierFormField.required
                                              }
                                              checked={
                                                this.state.adult[
                                                  wavierFormField.keyName
                                                ] || false
                                              }
                                              onChange={(event) =>
                                                this.updateState(
                                                  "adult",
                                                  wavierFormField.keyName,
                                                  event.target.value
                                                )
                                              }
                                            />
                                            {wavierFormField.required && (
                                              <span
                                                style={{
                                                  color: "red",
                                                  marginLeft: "5px",
                                                }}
                                              >
                                                *
                                              </span>
                                            )}
                                          </div>
                                          <Input
                                            id={index}
                                            type="textarea"
                                            disabled
                                            style={{ height: "160px" }}
                                            value={wavierFormField.value}
                                          />
                                        </>
                                      )}
                                    </FormGroup>
                                  </Col>
                                )
                              )}
                            </>
                          ) : null}
                        </TabPanel>
                        {this.state.registerChild && (
                          <TabPanel>
                            {this.state.registerFormFieldsPlayers.map(
                              (registerFormField, index) => (
                                <Col key={index}>
                                  <FormGroup>
                                    {registerFormField.inputType === "text" && (
                                      <>
                                        <Label>
                                          {registerFormField.placeholder}
                                          {registerFormField.required && (
                                            <span
                                              style={{
                                                color: "red",
                                                marginLeft: "5px",
                                              }}
                                            >
                                              *
                                            </span>
                                          )}
                                        </Label>
                                        <Input
                                          disabled={
                                            this.state.playerDisabledFields
                                          }
                                          id={index}
                                          name={registerFormField.name}
                                          type="text"
                                          value={
                                            this.state.player[
                                              registerFormField.keyName
                                            ] || ""
                                          }
                                          onChange={(event) =>
                                            this.updateState(
                                              "player",
                                              registerFormField.keyName,
                                              event.target.value
                                            )
                                          }
                                          placeholder={
                                            registerFormField.placeholder
                                          }
                                          required={registerFormField.required}
                                        />
                                      </>
                                    )}
                                    {registerFormField.inputType ===
                                      "number" && (
                                      <>
                                        <Label>
                                          {registerFormField.placeholder}
                                          {registerFormField.required && (
                                            <span
                                              style={{
                                                color: "red",
                                                marginLeft: "5px",
                                              }}
                                            >
                                              *
                                            </span>
                                          )}
                                        </Label>
                                        <Input
                                          disabled={
                                            this.state.playerDisabledFields
                                          }
                                          id={index}
                                          name={registerFormField.name}
                                          type="number"
                                          value={
                                            this.state.player[
                                              registerFormField.keyName
                                            ] || ""
                                          }
                                          onChange={(event) =>
                                            event.target.value > -1 &&
                                            this.updateState(
                                              "player",
                                              registerFormField.keyName,
                                              event.target.value
                                            )
                                          }
                                          placeholder={
                                            registerFormField.placeholder
                                          }
                                          required={registerFormField.required}
                                        />
                                      </>
                                    )}
                                    {registerFormField.inputType ===
                                      "datepicker" && (
                                      <>
                                        <Label>
                                          {registerFormField.placeholder}
                                          {registerFormField.required && (
                                            <span
                                              style={{
                                                color: "red",
                                                marginLeft: "5px",
                                              }}
                                            >
                                              *
                                            </span>
                                          )}
                                        </Label>
                                        <Input
                                          disabled={
                                            this.state.playerDisabledFields
                                          }
                                          id={index}
                                          name={registerFormField.name}
                                          type="date"
                                          value={
                                            this.state.player[
                                              registerFormField.keyName
                                            ] || ""
                                          }
                                          onChange={(event) =>
                                            this.updateState(
                                              "player",
                                              registerFormField.keyName,
                                              event.target.value
                                            )
                                          }
                                          placeholder={
                                            registerFormField.placeholder
                                          }
                                          required={registerFormField.required}
                                        />
                                      </>
                                    )}
                                    {registerFormField.inputType ===
                                      "dropdown" && (
                                      <>
                                        <Label>
                                          {registerFormField.placeholder}
                                          {registerFormField.required && (
                                            <span
                                              style={{
                                                color: "red",
                                                marginLeft: "5px",
                                              }}
                                            >
                                              *
                                            </span>
                                          )}
                                        </Label>
                                        <Input
                                          disabled={
                                            this.state.playerDisabledFields
                                          }
                                          type="select"
                                          name={registerFormField.name}
                                          value={
                                            this.state.player[
                                              registerFormField.keyName
                                            ] || "default"
                                          }
                                          required={registerFormField.required}
                                          onChange={(event) =>
                                            this.updateState(
                                              "player",
                                              registerFormField.keyName,
                                              event.target.value
                                            )
                                          }
                                        >
                                          <option value="default" disabled>
                                            Select the value
                                          </option>
                                          {registerFormField.values.map(
                                            (value, index) => (
                                              <option key={index} value={value}>
                                                {value}
                                              </option>
                                            )
                                          )}
                                        </Input>
                                      </>
                                    )}
                                    {registerFormField.inputType ===
                                      "fileupload" && (
                                      <>
                                        <Label>
                                          {registerFormField.placeholder}
                                          {registerFormField.required && (
                                            <span
                                              style={{
                                                color: "red",
                                                marginLeft: "5px",
                                              }}
                                            >
                                              *
                                            </span>
                                          )}
                                        </Label>
                                        <div>
                                          {this.state.playerDisabledFields ? (
                                            <CardImg
                                              style={{ width: "25%" }}
                                              key={index}
                                              src={this.getImageUrl(
                                                registerFormField.keyName,
                                                "player"
                                              )}
                                              alt=""
                                            />
                                          ) : (
                                            <>
                                              <Label
                                                htmlFor={registerFormField._id}
                                              >
                                                <span className="btn btn-secondary">
                                                  Select File
                                                </span>
                                                <span
                                                  style={{ marginLeft: "5px" }}
                                                >
                                                  {
                                                    this.state.player[
                                                      `${registerFormField.keyName}FileName`
                                                    ]
                                                  }
                                                </span>
                                              </Label>
                                              <input
                                                style={{ display: "none" }}
                                                id={registerFormField._id}
                                                type="file"
                                                onChange={(event) =>
                                                  this.handleChange(
                                                    "player",
                                                    registerFormField.keyName,
                                                    event
                                                  )
                                                }
                                              />
                                            </>
                                          )}
                                        </div>
                                      </>
                                    )}
                                  </FormGroup>
                                </Col>
                              )
                            )}
                            {this.state.wavierFormFieldsPlayers.length &&
                            !this.state.playerDisabledFields ? (
                              <>
                                <Col
                                  style={{
                                    textAlign: "center",
                                    padding: "10px 0px",
                                    borderTop: "3px solid #e4e5e6",
                                  }}
                                >
                                  <h3>Waviers For Players</h3>
                                </Col>
                                {this.state.wavierFormFieldsPlayers.map(
                                  (wavierFormField, index) => (
                                    <Col key={index}>
                                      <FormGroup>
                                        {wavierFormField.inputType ===
                                          "waviers" && (
                                          <>
                                            <div className="d-flex">
                                              <CustomInput
                                                type="checkbox"
                                                id={wavierFormField._id}
                                                label={
                                                  wavierFormField.placeholder
                                                }
                                                required={
                                                  wavierFormField.required
                                                }
                                                checked={
                                                  this.state.player[
                                                    wavierFormField.keyName
                                                  ] || false
                                                }
                                                onChange={(event) =>
                                                  this.updateState(
                                                    "player",
                                                    wavierFormField.keyName,
                                                    event.target.value
                                                  )
                                                }
                                              />
                                              {wavierFormField.required && (
                                                <span
                                                  style={{
                                                    color: "red",
                                                    marginLeft: "5px",
                                                  }}
                                                >
                                                  *
                                                </span>
                                              )}
                                            </div>
                                            <Input
                                              id={index}
                                              type="textarea"
                                              disabled
                                              style={{ height: "160px" }}
                                              value={wavierFormField.value}
                                            />
                                          </>
                                        )}
                                      </FormGroup>
                                    </Col>
                                  )
                                )}
                              </>
                            ) : null}
                          </TabPanel>
                        )}
                      </Tabs>
                      <Col
                        style={{
                          padding: "5px 0px",
                          borderTop: "3px solid #e4e5e6",
                        }}
                      ></Col>
                      <Col
                        style={{
                          textAlign: "center",
                        }}
                      >
                        {this.state.registerChild ? (
                          <Button
                            type="submit"
                            onClick={() =>
                              this.setState({
                                registerFor: "child",
                                submitType: "submit",
                              })
                            }
                          >
                            Register Player
                          </Button>
                        ) : (
                          <Button
                            disabled={
                              !this.state.phoneOtpVerified ||
                              !this.state.emailOtpVerified
                            }
                            type="submit"
                            onClick={() =>
                              this.setState({
                                registerFor: "parent",
                                submitType: "submit",
                              })
                            }
                          >
                            Register Parent
                          </Button>
                        )}
                      </Col>
                    </Form>
                  </div>
                </Container>
              ) : (
                <Container>
                  <div
                    className="login-form"
                    style={{
                      marginTop: "20px",
                      maxWidth: "unset",
                    }}
                  >
                    <Col
                      style={{
                        textAlign: "center",
                        borderBottom: "3px solid #e4e5e6",
                        marginBottom: "10px",
                      }}
                    >
                      <h2>Registration form not found</h2>
                    </Col>
                  </div>
                </Container>
              )}
            </>
          )
        ) : null}
        {this.state.verificationModal ? (
          <Modal
            isOpen={this.state.verificationModal}
            toggle={(event) => this.toggleVerificationModal()}
            className="modal-md"
          >
            <ModalHeader
              style={{
                background: "#f8f9fa",
              }}
              toggle={(event) => this.toggleVerificationModal()}
            >
              Confirmantion
            </ModalHeader>
            <ModalBody
              style={{
                background: "#f8f9fa",
              }}
            >
              <Row>
                <Col>
                  <FormGroup>
                    <Label>Are you sure you want to register?</Label>
                  </FormGroup>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter
              style={{
                background: "#f8f9fa",
              }}
            >
              <Form className="form" onSubmit={this.onSubmit}>
                <Button
                  type="submit"
                  onClick={() =>
                    this.state.registerChild
                      ? this.setState({
                          submitType: "registerChild",
                        })
                      : this.setState({
                          submitType: "registerAdult",
                        })
                  }
                >
                  Register
                </Button>
              </Form>
              <Button onClick={() => this.toggleVerificationModal()}>
                Cancel
              </Button>{" "}
            </ModalFooter>
          </Modal>
        ) : null}
        <NotificationSystem
          dismissible={false}
          ref={(notificationSystem) =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
      </Fragment>
    );
  }
}

export default WebAppRegistrationForm;
